const rhythm = [
  { n: "01", label: "Welcome" },
  { n: "02", label: "Set today\u2019s focus" },
  { n: "03", label: "Quiet work time" },
  { n: "04", label: "Optional celebration before we head back into our lives" },
];

export function WhatToExpect() {
  return (
    <section
      data-testid="what-to-expect-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FAFAF8 0%, #F8F7F5 50%, #FAFAF8 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[20px] md:pt-[42px] pb-[44px] md:pb-[66px]">
        <div className="reveal grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
          <div className="lg:col-span-4">
            <h2 className="font-display text-4xl lg:text-[58px] leading-[1.08] tracking-tight text-[#1C1917] mb-4">
              What to Expect
            </h2>
            <p className="text-sm tracking-[0.14em] uppercase text-[#159E9A] mb-5">
              90-minute Zoom sessions
            </p>
            <p className="text-lg text-[#57534E] leading-relaxed">
              A simple rhythm.
            </p>
          </div>

          <div className="lg:col-span-8">
            {rhythm.map((r, i) => (
              <div
                key={r.n}
                data-testid={`expect-step-${r.n}`}
                className={`flex items-baseline gap-6 py-5 border-b border-[#E8E6E3] ${i === 0 ? "border-t" : ""}`}
              >
                <span className="font-display italic text-3xl md:text-4xl text-[#F6A041] w-14 md:w-16 flex-shrink-0">
                  {r.n}
                </span>
                <p className="text-lg md:text-xl text-[#1C1917] leading-relaxed">{r.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-[680px] mx-auto text-center mt-16 md:mt-20">
          <p className="text-lg md:text-xl text-[#57534E] leading-relaxed">Camera optional.</p>
          <p className="text-lg md:text-xl text-[#57534E] leading-relaxed">Come exactly as you are.</p>
          <p className="font-display text-[30px] sm:text-[40px] lg:text-[50px] leading-tight text-[#1C1917] mt-5">
            Leave a little further along than when you arrived.
          </p>
        </div>
      </div>
    </section>
  );
}
